import { FadeUp } from "./Motion";

const sources = [
  {
    name: "Surepass",
    role: "Bank statement analysis, GST data, e-Invoice verification",
  },
  {
    name: "CIBIL Commercial",
    role: "Commercial credit reports, CreditVision Commercial Rank",
  },
  {
    name: "Account Aggregator",
    role: "Consent-based financial data sharing (Sahamati framework)",
  },
  {
    name: "GST Network (GSTN)",
    role: "Government GST compliance data, GSTR-2A verification",
  },
];

export const DataSources = () => {
  return (
    <section
      id="data-sources"
      className="relative py-20 md:py-28 border-t border-ink/10 bg-paper"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className="flex items-center gap-6 mb-12">
            <span className="font-mono-cap text-ink/60">Note — Verified Data Sources</span>
            <span className="hair-divider flex-1" />
          </div>
        </FadeUp>

        <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
          <div className="col-span-12 lg:col-span-5">
            <FadeUp>
              <h3 className="font-display text-4xl md:text-5xl text-ink leading-[1] tracking-tight">
                Built on <br />
                <span className="italic text-teal">enterprise APIs</span>.
              </h3>
            </FadeUp>
            <FadeUp delay={0.1}>
              <p className="font-sans text-ink/70 leading-relaxed mt-6 max-w-md">
                Credablr integrates with RBI-approved, enterprise-grade data
                providers — with MSME consent and regulatory compliance built in.
              </p>
            </FadeUp>
          </div>

          <div className="col-span-12 lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
            {sources.map((s, i) => (
              <FadeUp key={s.name} delay={i * 0.06}>
                <div className="border-t border-ink/20 pt-5">
                  <div className="font-display text-xl md:text-2xl text-ink">
                    {s.name}
                  </div>
                  <p className="font-sans text-sm text-ink/70 mt-2 leading-relaxed">
                    {s.role}
                  </p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
